import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class SecurityService{
    r: any;
    n: any;
    i: any;
    s: number;
    o: number;
    u: number;
    a: number;
    t: any;
    f:number;
    c1:any;
    c2;any;
    c3:any;
constructor (

)
{}
 _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

 encode(e) {
     var t = "";
     var n,r,i,s,o,u,a;
     var f = 0;
     e = this.utf8_encode(e);
     while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = (n & 3) << 4 | r >> 4;
        u = (r & 15) << 2 | i >> 6;
        a = i & 63;
        if (isNaN(r)) {
            u = a = 64;
        } else if (isNaN(i)) {
            a = 64;
        }
        t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
    }
    return t;
 }
 decode(e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (f < e.length) {
        s = this._keyStr.indexOf(e.charAt(f++));
        o = this._keyStr.indexOf(e.charAt(f++));
        u = this._keyStr.indexOf(e.charAt(f++));
        a = this._keyStr.indexOf(e.charAt(f++));
        n = s << 2 | o >> 4;
        r = (o & 15) << 4 | u >> 2;
        i = (u & 3) << 6 | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
            t = t + String.fromCharCode(r)
        }
        if (a != 64) {
            t = t + String.fromCharCode(i)
        }
    }
    t = this.utf8_decode(t);
    return t;
 }
 utf8_encode(e) {
    e = e.replace(/\r\n/g, "\n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
            t += String.fromCharCode(r >> 6 | 192);
            t += String.fromCharCode(r & 63 | 128);
        } else {
            t += String.fromCharCode(r >> 12 | 224);
            t += String.fromCharCode(r >> 6 & 63 | 128);
            t += String.fromCharCode(r & 63 | 128);
        }
    }
    return t;
 }
 
 utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = this.c1 = this.c2 = 0;
    while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
            n++;
        } else if (r > 191 && r < 224) {
            this.c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode((r & 31) << 6 | this.c2 & 63);
            n += 2;
        } else {
            this.c2 = e.charCodeAt(n + 1);
            this.c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode((r & 15) << 12 | (this.c2 & 63) << 6 | this.c3 & 63);
            n += 3;
        }
    }
    return t;
 }
base64Encode(data) {
    return this.encode(data);
}
base64Decode(data) {
    return this.decode(data);
}

}